import { Options, useHotkeys } from 'react-hotkeys-hook';
import { useMapEditor } from '../../../contexts/MapEditorContext';
import { useEditorShortcuts } from '../EditorShortcutContext/useEditorShortcuts';
import { GLOBAL_SHORTCUTS_SCOPE } from '../shortcuts';

export const useGlobalEditorShortcuts = () => {
  const {
    setActiveTool,
    copySelectedShapes,
    pasteShapes,
    undo,
    redo,
    setSelectedIds,
    selectedIds,
    clipboard,
    shapes,
    groupSelected,
    ungroupShapes
  } = useMapEditor();
  const { shortcuts } = useEditorShortcuts();

  const enabled = true;
  const scopes = [GLOBAL_SHORTCUTS_SCOPE];
  const preventDefault = true;

  const shortcutOptions: Options = { scopes, enabled, preventDefault };

  useHotkeys(
    shortcuts.global.selectionTool,
    () => {
      setActiveTool('select');
    },
    shortcutOptions,
    [shortcuts.global.selectionTool]
  );

  useHotkeys(
    shortcuts.global.drawSelectTool,
    () => {
      setActiveTool('draw-select');
    },
    shortcutOptions,
    [shortcuts.global.drawSelectTool]
  );

  useHotkeys(
    shortcuts.global.iconTool,
    () => {
      setActiveTool('icon');
    },
    shortcutOptions,
    [shortcuts.global.iconTool]
  );

  useHotkeys(
    shortcuts.global.panTool,
    () => {
      setActiveTool('pan');
    },
    shortcutOptions,
    [shortcuts.global.panTool]
  );

  useHotkeys(
    shortcuts.global.groupSelected,
    (event) => {
      if (selectedIds.length > 1) {
        event.preventDefault();
        groupSelected();
      }
    },
    shortcutOptions,
    [selectedIds, shortcuts.global.groupSelected]
  );

  useHotkeys(
    shortcuts.global.unGroupSelected,
    (event) => {
      shapes
        .filter((shape) => shape.type === 'group')
        .forEach((shape) => {
          event.preventDefault();
          ungroupShapes(shape.id);
        });
    },
    shortcutOptions,
    [selectedIds, shortcuts.global.unGroupSelected, shapes]
  );

  useHotkeys(
    shortcuts.global.copy,
    (event) => {
      event.preventDefault();
      copySelectedShapes();
    },
    shortcutOptions,
    [selectedIds, shortcuts.global.copy]
  );

  useHotkeys(
    shortcuts.global.paste,
    (event) => {
      event.preventDefault();
      pasteShapes();
    },
    shortcutOptions,
    [selectedIds, shortcuts.global.paste, clipboard]
  );

  useHotkeys(
    shortcuts.global.undo,
    (event) => {
      event.preventDefault();
      undo();
    },
    shortcutOptions,
    [shortcuts.global.undo]
  );

  useHotkeys(
    shortcuts.global.redo,
    (event) => {
      event.preventDefault();
      redo();
    },
    shortcutOptions,
    [shortcuts.global.redo]
  );

  useHotkeys(
    shortcuts.global.selectAll,
    (event) => {
      event.preventDefault();
      setSelectedIds(
        shapes
          .filter((shape) => !shape.locked && !shape.hidden)
          .map((shape) => shape.id)
      );
    },
    shortcutOptions,
    [shortcuts.global.selectAll, shapes]
  );

  useHotkeys(
    shortcuts.global.deselectAll,
    (event) => {
      event.preventDefault();
      setSelectedIds([]);
    },
    shortcutOptions,
    [shortcuts.global.deselectAll, shapes]
  );
};
